/* Chic and Bling - collection page part 2: injected blocks.
   Progressive enhancement. If this file fails, the page is stock Dawn plus the
   CSS-only effects; nothing here is required for browsing or buying.

   Injects two things:
   1. A short benefit strip above the grid (surfaces personalisation, which is
      the actual differentiator and is otherwise invisible until the product page).
   2. One editorial tile inside the grid, Missoma-style.

   Both are idempotent and re-run after Dawn replaces the grid on filter/sort. */
(function () {
  'use strict';

  /* Position of the editorial tile within the grid, and the minimum number of
     products required before it is worth breaking the grid at all. */
  var ED_AFTER = 8;
  var ED_MIN_ITEMS = 12;

  function buildUSP() {
    var wrap = document.createElement('div');
    wrap.className = 'cb-usp';
    wrap.setAttribute('data-cb-usp', '');

    var items = [
      {
        lead: true,
        title: 'Personalise any piece',
        body: 'Add your own photo or the months that matter.'
      },
      {
        title: 'Free standard shipping',
        body: 'On every order, no minimum.'
      },
      {
        title: 'Every birthstone',
        body: 'All twelve months, matched to the right stone.'
      }
    ];

    items.forEach(function (it) {
      var d = document.createElement('div');
      d.className = 'cb-usp__item' + (it.lead ? ' cb-usp__item--lead' : '');
      var b = document.createElement('b');
      b.textContent = it.title;
      var s = document.createElement('span');
      s.textContent = it.body;
      d.appendChild(b);
      d.appendChild(s);
      wrap.appendChild(d);
    });

    return wrap;
  }

  function injectUSP() {
    if (document.querySelector('[data-cb-usp]')) return;
    var col = document.querySelector('.collection');
    if (!col) return;
    col.insertBefore(buildUSP(), col.firstChild);
  }

  function buildEditorial() {
    var a = document.createElement('li');
    a.className = 'grid__item';
    a.setAttribute('data-cb-ed', '');

    var link = document.createElement('a');
    link.className = 'cb-ed';
    link.href = '/collections/birthstone-by-month';

    var body = document.createElement('div');
    body.className = 'cb-ed__body';

    var eyebrow = document.createElement('span');
    eyebrow.className = 'cb-ed__eyebrow';
    eyebrow.textContent = 'Shop by month';

    var title = document.createElement('span');
    title.className = 'cb-ed__title';
    title.textContent = 'Find their birthstone';

    var cta = document.createElement('span');
    cta.className = 'cb-ed__cta';
    cta.textContent = 'Browse all twelve';

    body.appendChild(eyebrow);
    body.appendChild(title);
    body.appendChild(cta);
    link.appendChild(body);
    a.appendChild(link);
    return a;
  }

  function injectEditorial() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    if (grid.querySelector('[data-cb-ed]')) return;

    var items = grid.querySelectorAll('.grid__item');
    // Do not break a short grid - it just looks like a gap.
    if (items.length < ED_MIN_ITEMS) return;

    var anchor = items[ED_AFTER];
    if (!anchor) return;
    grid.insertBefore(buildEditorial(), anchor);
  }

  function init() {
    injectUSP();
    injectEditorial();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Dawn rebuilds #product-grid on filter/sort/paginate without a page load,
     which drops the injected tile. Re-add it after the swap settles. */
  if ('MutationObserver' in window) {
    var host = document.querySelector('.collection') || document.body;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(init, 80);
    }).observe(host, { childList: true, subtree: true });
  }
})();
